/**
 * @module modules/favorites-dialog-sk
 * @description <h2><code>favorites-dialog-sk</code></h2>
 *
 * This module is a modal that contains a form to capture user
 * input for adding/editing a new favorite.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FavoritesDialogSk", {
    enumerable: true,
    get: function() {
        return FavoritesDialogSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _live = require("lit/directives/live.js");
const _errorMessage = require("../../../elements-sk/modules/errorMessage");
require("../../../elements-sk/modules/spinner-sk");
require("../../../elements-sk/modules/icons/close-icon-sk");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _FavoritesDialogSk;
let FavoritesDialogSk = (_FavoritesDialogSk = class FavoritesDialogSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    dismiss() {
        this.dialog.close();
        if (this.reject) {
            this.reject();
        }
    }
    toggleIncludeTime() {
        this.includeTime = !this.includeTime;
        this.url = this.getFilteredUrl(this.originalUrl, this.includeTime);
    }
    getFilteredUrl(urlStr, includeTime) {
        try {
            const url = new URL(urlStr, window.location.origin);
            if (!includeTime) {
                let modified = false;
                if (url.searchParams.has('begin')) {
                    url.searchParams.delete('begin');
                    modified = true;
                }
                if (url.searchParams.has('end')) {
                    url.searchParams.delete('end');
                    modified = true;
                }
                if (modified) {
                    return url.toString();
                }
            }
            return urlStr;
        } catch (_e) {
            return urlStr;
        }
    }
    async confirm() {
        if (this.name === '' || this.url === '') {
            (0, _errorMessage.errorMessage)('Name and url must be non empty');
            return;
        }
        let apiUrl = '/_/favorites/new';
        let body = {
            name: this.name,
            description: this.description,
            url: this.url
        };
        if (this.favId !== '') {
            body = _object_spread_props(_object_spread({}, body), {
                id: this.favId
            });
            apiUrl = '/_/favorites/edit';
        }
        try {
            this.updatingFavorite = true;
            const resp = await fetch(apiUrl, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!resp.ok) {
                const msg = await resp.text();
                (0, _errorMessage.errorMessage)(`${resp.statusText}: ${msg}`);
            }
        } finally{
            this.updatingFavorite = false;
            this.dialog.close();
            if (this.resolve) {
                this.resolve();
            }
        }
    }
    // open shows the popup dialog when called.
    async open(favId, name, description, url) {
        this.favId = favId || '';
        this.name = name || '';
        this.description = description || '';
        this.originalUrl = url || window.location.href;
        this.includeTime = false;
        this.url = this.getFilteredUrl(this.originalUrl, this.includeTime);
        await this.updateComplete;
        this.dialog.showModal();
        // If the dialog closes it could be due to 2 reasons:
        //    1: User pressed on close
        //    2: The favorite got added/edited.
        // In this module, we want to re-fetch the favorites when the dialog is closed
        // but we only want to re-fetch if closed due to reason 2.
        // So we're using the reject function when the user presses on close dialog
        // which is eventually used in favorites-sk to decide if it wants to
        // re-fetch the favorites or not.
        return await new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    render() {
        return (0, _lit.html)`
      <dialog class="fav-dialog">
        <h2>Favorite</h2>

        <button class="close-btn" @click=${this.dismiss}>
          <close-icon-sk></close-icon-sk>
        </button>

        <div class="spin-container">
          <spinner-sk ?active=${this.updatingFavorite}></spinner-sk>
        </div>

        <span class="label">
          <label for="name-${this.uniqueId}">Name*</label>
        </span>
        <input
          id="name-${this.uniqueId}"
          placeholder="Name"
          .value="${(0, _live.live)(this.name)}"
          @input=${(e)=>this.name = e.target.value}>
        </input>
        <br/>

        <span class="label">
          <label for="desc-${this.uniqueId}">Description</label>
        </span>
        <input
          id="desc-${this.uniqueId}"
          placeholder="Description"
          .value="${(0, _live.live)(this.description)}"
          @input=${(e)=>this.description = e.target.value}></input>
        <br/>

        <span class="label">
          <label for="url-${this.uniqueId}">URL*</label>
        </span>
        <input
          id="url-${this.uniqueId}"
          placeholder="URL"
          .value="${(0, _live.live)(this.url)}"
          @input=${(e)=>this.url = e.target.value}></input>
        <br/>

        <div class="include-time-container">
          <input
            id="include-time-${this.uniqueId}"
            type="checkbox"
            .checked=${this.includeTime}
            @change=${this.toggleIncludeTime}>
          <label for="include-time-${this.uniqueId}">Include begin and end time in URL</label>
        </div>
        <br/>

        <div ?hidden="${!this.updatingFavorite}">
          Working on it...
        </div>

        <div class="buttons">
          <button ?disabled="${this.updatingFavorite}" @click=${this.dismiss}>Cancel</button>
          <button ?disabled="${this.updatingFavorite}" @click=${this.confirm}>Save</button>
        </div>
      </dialog>`;
    }
    constructor(...args){
        super(...args);
        this.uniqueId = `${FavoritesDialogSk.nextUniqueId++}`;
        this.favId = '';
        this.name = '';
        this.description = '';
        this.url = '';
        this.updatingFavorite = false;
        this.includeTime = false;
        this.originalUrl = '';
        this.resolve = null;
        this.reject = null;
    }
}, (()=>{
    _FavoritesDialogSk.nextUniqueId = 0;
})(), _FavoritesDialogSk);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], FavoritesDialogSk.prototype, "favId", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], FavoritesDialogSk.prototype, "name", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], FavoritesDialogSk.prototype, "description", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], FavoritesDialogSk.prototype, "url", void 0);
_ts_decorate([
    (0, _decorators.query)('dialog'),
    _ts_metadata("design:type", typeof HTMLDialogElement === "undefined" ? Object : HTMLDialogElement)
], FavoritesDialogSk.prototype, "dialog", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], FavoritesDialogSk.prototype, "updatingFavorite", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], FavoritesDialogSk.prototype, "includeTime", void 0);
FavoritesDialogSk = _ts_decorate([
    (0, _decorators.customElement)('favorites-dialog-sk')
], FavoritesDialogSk);
